// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1htTT","label":"Completed_label__3h1Hx"};